// extracted by mini-css-extract-plugin
export var actionButton = "_rn-0";
export var actionMenuContainer = "_rn-i";
export var bubble = "_rn-2";
export var bubbleActionMenu = "_rn-j";
export var bubbleContext = "_rn-6";
export var bubbleItems = "_rn-7";
export var customer = "_rn-3";
export var divider = "_rn-8";
export var fileList = "_rn-9";
export var hiddenComment = "_rn-o";
export var infoAbove = "_rn-a";
export var internal = "_rn-4";
export var lightActionButton = "_rn-1";
export var link = "_rn-b";
export var merchant = "_rn-5";
export var message = "_rn-c";
export var profilePicture = "_rn-e";
export var quillToolbarContainer = "_rn-f";
export var senderDate = "_rn-g";
export var senderDateCustomer = "_rn-h";
export var senderName = "_rn-d";
export var time = "_rn-k";
export var uploadedImage = "_rn-l";
export var username = "_rn-m";
export var xsmall = "_rn-n";